import React, {Component} from 'react';

//podczas liczenia dodac film
class Loaderspiner extends Component {
  render () {
    
    
    return [
      
        
            <div className="ispinner" key={2}>
                <div className="ispinner-blade"></div>
                <div className="ispinner-blade"></div>
                <div className="ispinner-blade"></div>
                <div className="ispinner-blade"></div>
                <div className="ispinner-blade"></div>
                <div className="ispinner-blade"></div>
                <div className="ispinner-blade"></div>
                <div className="ispinner-blade"></div>
            </div>
         
        
     
    ]
  }
}



export default Loaderspiner;